const { __, sprintf } = wp.i18n;

const getShapesForSvgMap = (shapes, plotNumbers, selectedPlotId, statuses) => (
	shapes.filter(shape => plotNumbers.findIndex(plotNumber => plotNumber.id === getPlotNumberIdFromShapeLink(shape.link)) >= 0).map(shape => {
		const plotNumber = plotNumbers.find(plotNumber => plotNumber.id === getPlotNumberIdFromShapeLink(shape.link));
		return {
			...shape,
			status: plotNumber.status.value,
			isHighlighted: statuses.filter(status => status.isSelected).map(status => status.value).indexOf(plotNumber.status.value) >= 0,
			isSelected: plotNumber.id === selectedPlotId
		};
	})
);

const getPlotNumberIdFromShapeLink = (link) => {
	const parts = link.split(':');
	return parts[0] === 'plot-number' ? parseInt(parts[1], 10) : null;
};

// TODO: mapping is are never a good thing
const mapFieldNameToPlotMapPropertyForModal = (name, plotNumber) => {
	switch (name) {
	case 'name':
		return plotNumber.name;
	case 'b_bouwnummer':
		return plotNumber.number;
	case 'plot_type_of_house':
		return plotNumber.houseType.label;
	case 'w_kaveloppervlakte':
		return plotNumber.lotAreaInSquareMetersFormatted;
	case 'w_woonoppervlakte':
		return plotNumber.livingAreaInSquareMetersFormatted;
	case 'w_inhoud':
		return plotNumber.contentInCubicMetersFormatted;
	case 'w_balkonoppervlakte':
		return plotNumber.balconySurfaceInSquareMetersFormatted;
	case 'plot_balcony_location':
		return plotNumber.balconyLocation.label;
	case 'plot_terrace_surface':
		return plotNumber.terraceSurfaceInSquareMetersFormatted;
	case 'plot_terrace_location':
		return plotNumber.terraceLocation.label;
	case 'plot_other_indoor_space':
		return plotNumber.otherIndoorSpaceInSquareMetersFormatted;
	case 'plot_building_related_outdoor_space':
		return plotNumber.buildingRelatedOutdoorSpaceInSquareMetersFormatted;
	case 'plot_external_storage_space':
		return plotNumber.getExternalStorageInSquareMetersFormatted;
	case 'plot_number_of_rooms':
		return plotNumber.numberOfRooms;
	case 'w_number_of_bedrooms':
		return plotNumber.numberOfBedrooms;
	case 'w_number_of_bathrooms':
		return plotNumber.numberOfBathrooms;
	case 'plot_garden_location':
		return plotNumber.gardenLocation.label;
	case 'plot_garden_surface':
		return plotNumber.gardenSurfaceInSquareMetersFormatted;
	case 'plot_floor':
		return plotNumber.floor;
	case 'w_prijs':
		return plotNumber.priceFormattedWithComposition;
	case 'w_prijsbereik':
		return plotNumber.priceRangeFormatted?.from && plotNumber.priceRangeFormatted?.to ? sprintf(__('%s to %s %s', 'real-estate-project'), plotNumber.priceRangeFormatted.from, plotNumber.priceRangeFormatted.to, plotNumber.priceRangeCompositionSuffix) : '';
	case 'w_status':
		return plotNumber.status.label;
	case 'house-model-name':
		return plotNumber.houseModel?.name ? plotNumber.houseModel.name : '';
	}

	return null;
};

const getPlotNumberForModal = (plotNumber, infoToShow) => {
	if (!plotNumber) {
		return plotNumber;
	}

	return {
		...plotNumber,
		properties: infoToShow.map(info => ({
			...info,
			value: mapFieldNameToPlotMapPropertyForModal(info.name, plotNumber)
		})).filter(property => property.value)
	};
};

export {
	getShapesForSvgMap,
	getPlotNumberForModal,
	getPlotNumberIdFromShapeLink
};